if (!customElements.get('product-form')) {
  class ProductForm extends HTMLElement {
    constructor() {
      super();
      if (this.hasChildNodes()) this.init();
    }

    init() {
      this.form = this.querySelector('.js-product-form');
      if (this.form) {
        this.form.querySelector('[name="id"]').disabled = false;
        this.cartDrawer = document.querySelector('cart-drawer');
        this.submitBtn = this.querySelector('[name="add"]');

        if (theme.settings.afterAtc !== 'no-js') {
          this.addEventListener('submit', this.handleSubmit.bind(this));
        }
      }
    }

    async addCoreChargeToCart(corePriceid, qua = 1) {
      let data;
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          quantity: qua,
          id: corePriceid,
          properties: {
            'Core_Charge': corePriceid
          }
        })
      }
      await fetch('/cart/add.js', requestOptions)
        .then(response => response.json())
        .then(data => {
          console.log("done")
        }).catch(error => {
          console.error('There was an error!', error);
        });
    }

    /**
     * Handles submission of the product form.
     * @param {object} evt - Event object.
     */
    async handleSubmit(evt) {
      if (evt.target.id === 'product-signup_form') return;

      evt.preventDefault();

      if (this.submitBtn.getAttribute('aria-disabled') === 'true') return;

      if (theme.settings.vibrateOnATC && window.navigator.vibrate) {
        window.navigator.vibrate(100);
      }

      this.errorMsg = null;
      this.setErrorMsgState();
      let quantityInput = this.form.querySelector('[name="quantity"]');
      const formMinimum = Number(this.dataset.minimumQuantity) || 1;
      if (!quantityInput && formMinimum > 1) {
        quantityInput = document.createElement('input');
        quantityInput.type = 'hidden';
        quantityInput.name = 'quantity';
        quantityInput.dataset.minimumQuantity = formMinimum;
        this.form.appendChild(quantityInput);
      }
      if (quantityInput) {
        const minimum = Number(quantityInput.dataset.minimumQuantity || quantityInput.step || quantityInput.min || formMinimum) || 1;
        const requestedQuantity = Number(quantityInput.value);
        quantityInput.value = Number.isFinite(requestedQuantity) && requestedQuantity > 0
          ? Math.max(minimum, Math.ceil(requestedQuantity / minimum) * minimum)
          : minimum;
      }
      //we can write core charge function call here.
      var coreChargeid = $("[name='properties[_core_charge_product_id]']").attr(
        "value"
      );
      var quantity = quantityInput ? quantityInput.value : 1;
      console.log("Below valuies");
      if (coreChargeid) {
        var corePriceid = coreChargeid;
        if (corePriceid) {
            await this.addCoreChargeToCart(corePriceid, quantity);
        } else {
          console.error("Invalid core price:", corePriceMetafield);
        }
      }

      // Disable "Add to Cart" button until submission is complete.
      this.submitBtn.setAttribute('aria-disabled', 'true');
      this.submitBtn.classList.add('is-loading');
      let isQuickOrder = this.form.getAttribute('quick-order');
      let sections = 'cart-icon-bubble';
          if (this.cartDrawer) {
            sections += `,${this.cartDrawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
          }
      if(isQuickOrder == 'true'){
        var items = [];
          document.querySelectorAll('.variant-item input').forEach(ele => {
              let qnt = ele.value;
              let id = ele.getAttribute('data-variant-id');
              if(qnt > 0) {
                  let item = {
                      'quantity': qnt,
                      'id': id
                  };
                  items.push(item);
              }
          });
        
        var fetchRequestOpts = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 'items': items })
        };
        if(items.length == 0){
          const error = "Please select the quantity";
          this.setErrorMsgState(error);
          this.submitBtn.removeAttribute('aria-disabled');
          this.submitBtn.classList.remove('is-loading');
          return false; 
        }
        const response = await fetch(theme.routes.cartAdd + ".js", fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;
        if (!response.ok){
          this.setErrorMsgState(error);
          this.submitBtn.classList.add('is-success');
          this.submitBtn.removeAttribute('aria-disabled');
          setTimeout(() => {
            this.submitBtn.classList.remove('is-loading');
            this.submitBtn.classList.remove('is-success');
          }, 1400);
        }
      }else{
         this.syncPriceProperties();
         const formData = new FormData(this.form);
    
          formData.append('sections_url', window.location.pathname);
          formData.append('sections', sections);
          // console.log('[APG ATC] FormData sent ' + JSON.stringify(
          //   [...formData.entries()].filter(([k]) => k !== 'sections' && k !== 'sections_url')
          // ));
    
          let fetchRequestOpts = {
            method: 'POST',
            headers: {
              Accept: 'application/javascript',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: formData
          }; 
        let response;
        try {
          response = await fetch(theme.routes.cartAdd, fetchRequestOpts);
        } catch (e) {
          // console.error('[APG ATC] Cart add fetch threw', e);
          throw e;
        }
        // console.log('[APG ATC] Cart add HTTP ' + response.status + ' ' + response.url);
        let added = null;
        try {
          added = await response.clone().json();
          // console.log('[APG ATC] Cart add response ' + JSON.stringify({
          //   status: response.status,
          //   key: added.key,
          //   variant_id: added.variant_id,
          //   price: added.price,
          //   original_price: added.original_price,
          //   final_price: added.final_price,
          //   properties: added.properties,
          //   error: added.description || added.message || null
          // }));
        } catch (e) {
          // console.warn('[APG ATC] Could not parse cart add response', response.status, e);
        }

        if (!response.ok) {
          this.setErrorMsgState(added?.description || added?.message || 'Unable to add this item to your cart.');
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.removeAttribute('aria-disabled');
          return;
        }
      }
      var fetchRequestOpts ={
            method: 'GET'
          }; 
      var url = window.location.pathname +"?sections_url="+window.location.pathname+ "&sections="+ sections;
      try {
        const oldCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!oldCartResponse.ok) throw new Error(oldCartResponse.status);
        const oldCartData = await oldCartResponse.json();

        const response = await fetch(url, fetchRequestOpts);
        const data = await response.json();
        const error = typeof data.description === 'string' ? data.description : data.message;

        if (data.status) this.setErrorMsgState(error);

        if (!response.ok) throw new Error(response.status);

        if (theme.settings.afterAtc === 'page') {
          // Allow the tick animation to complete
          setTimeout(() => {
            window.location.href = theme.routes.cart;
          }, 300);
        } else {
          // Update cart icon count.
          let cdata = { sections: data };
          ProductForm.updateCartIcon(cdata);

          // If item was added from Quick Add drawer, show "Added to cart" message.
          const quickAddDrawer = this.closest('quick-add-drawer');
          if (quickAddDrawer) quickAddDrawer.addedToCart();

          setTimeout(() => {
            // Update cart drawer contents.
            if (this.cartDrawer) {
              this.cartDrawer.renderContents(
                cdata,
                !quickAddDrawer && theme.settings.afterAtc === 'drawer'
              );
            } else if (window.location.pathname === theme.routes.cart) {
              const cartItems = document.querySelector('cart-items');
              if (cartItems) {
                if (cartItems.dataset.empty === 'true') {
                  window.location.reload();
                } else {
                  cartItems.refresh();
                }
              }
            }
          }, 700);
        }

        const newCartResponse = await fetch(`${theme.routes.cart}.js`);
        if (!newCartResponse.ok) throw new Error(newCartResponse.status);
        const newCartData = await newCartResponse.json();
        const itemInOldCart = oldCartData.items.filter(
          (item) => item.variant_id === data.variant_id
        )[0];

        // Check if product was already in the cart
        if (itemInOldCart) {
          this.dispatchEvent(new CustomEvent('on:line-item:change', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id,
              oldQuantity: itemInOldCart.quantity,
              newQuantity: (itemInOldCart.quantity === data.quantity)
                ? itemInOldCart.quantity : data.quantity
            }
          }));
        } else {
          this.dispatchEvent(new CustomEvent('on:cart:add', {
            bubbles: true,
            detail: {
              cart: newCartData,
              variantId: data.variant_id
            }
          }));
        }
      } catch (error) {
        console.log(error); // eslint-disable-line
        this.dispatchEvent(new CustomEvent('on:cart:error', {
          bubbles: true,
          detail: {
            error: this.errorMsg.textContent
          }
        }));
      } finally {
        // Re-enable 'Add to Cart' button.
        this.submitBtn.classList.add('is-success');
        this.submitBtn.removeAttribute('aria-disabled');
        setTimeout(() => {
          this.submitBtn.classList.remove('is-loading');
          this.submitBtn.classList.remove('is-success');
        }, 1400);
      }
    }

    /**
     * Forces line item price/company properties to match what the PDP displays,
     * since the apg-interface app embed can rewrite these inputs with another company's price.
     */
    syncPriceProperties() {
      const scope = this.closest('.product-info, quick-add-drawer') || document;
      const priceEl = scope.querySelector('.product-info__price .price__current')
        || document.querySelector('.product-info__price .price__current');
      const domPrice = parseFloat((priceEl?.textContent || '').replace(/[^0-9.]/g, ''));
      const priceInput = this.form.querySelector('[name="properties[_price_override]"]');
      const companyInput = this.form.querySelector('[name="properties[_company_id]"]');

      const before = {
        priceOverride: priceInput?.value,
        companyId: companyInput?.value
      };

      if (priceInput && Number.isFinite(domPrice) && domPrice > 0) {
        priceInput.value = domPrice.toFixed(2);
      }
      if (companyInput && companyInput.dataset.liquidValue) {
        companyInput.value = companyInput.dataset.liquidValue;
      }

      // console.log('[APG ATC] Line item properties ' + JSON.stringify({
      //   formId: this.form.getAttribute('id'),
      //   domPrice: priceEl?.textContent?.trim() ?? null,
      //   priceInputFound: !!priceInput,
      //   companyInputFound: !!companyInput,
      //   before,
      //   after: { priceOverride: priceInput?.value ?? null, companyId: companyInput?.value ?? null }
      // }));
    }

    /**
     * Updates the cart icon count in the header.
     * @param {object} response - Response JSON.
     */
    static updateCartIcon(response) {
      const cartIconBubble = document.getElementById('cart-icon-bubble');
      if (cartIconBubble) {
        cartIconBubble.innerHTML = response.sections['cart-icon-bubble'];
      }
    }

    /**
     * Shows/hides an error message.
     * @param {string} [error=false] - Error to show a message for.
     */
    setErrorMsgState(error = false) {
      this.errorMsg = this.errorMsg || this.querySelector('.js-form-error');
      if (!this.errorMsg) return;

      this.errorMsg.hidden = !error;
      if (error) this.errorMsg.textContent = error;
    }
  }

  customElements.define('product-form', ProductForm);
}
